import { IPhotoAmateur } from 'redhotpie-shared-lib/interfaces/IUser';
import * as utils from '../functions/utils';

export default class PhotoAmateur {
  count: number;
  galleryType: string;

  constructor() {
    this.count = 0;
    this.galleryType = '';
  }

  static mappingObject(_amateur: any): IPhotoAmateur {
    let amateur = Object.assign(new PhotoAmateur(), _amateur);
    amateur.count = _amateur.Count;
    amateur.galleryType = _amateur.GalleryType;
    amateur = utils.cleanObjectKeys(Object.keys(new PhotoAmateur()), amateur);
    return amateur;
  }

  static mappingObjects(_amateurs: any[]): IPhotoAmateur[] {
    const amateurs: IPhotoAmateur[] = [];
    _amateurs.forEach(_amateur => {
      amateurs.push(PhotoAmateur.mappingObject(_amateur));
    });
    return amateurs;
  }
}
